// @flow
import * as React from 'react';
import PropTypes from 'prop-types';

const toastsManagerLoader = () =>
  import(/* webpackChunkName: "ToastsManagerCommon" */ 'app/common/lib/ToastsManager');

type InjectedProps = {|
  hideAllToasts: void | (() => mixed),
  showToast: void | ((Toast: React.ComponentType<any>) => mixed),
|};

export default function withShowToast<Props: {}>(
  Subject: React.AbstractComponent<Props>,
): React.AbstractComponent<$Diff<Props, InjectedProps>> {
  return class Toaster extends React.Component<$Diff<Props, InjectedProps>> {
    // $FlowFixMe: new errors found from flow 0.96 upgrade
    static displayName = `WithShowToast(${Subject.displayName || Subject.name})`;
    static contextTypes = {
      showToast: PropTypes.func,
      hideAllToasts: PropTypes.func,
    };

    showToast = (Toast: React.ComponentType<any>) => {
      if (!this.context.showToast) {
        // Display react toasts in Denzel.
        // TODO(bca): remove this once pure react ramps to 100%.
        toastsManagerLoader().then(({ default: ToastsManager }) => {
          ToastsManager.showReactToast(Toast);
        });
      } else {
        this.context.showToast(Toast);
      }
    };

    hideAllToasts = () => {
      if (!this.context.hideAllToasts) {
        // TODO(bca): remove this once pure react ramps to 100%.
        toastsManagerLoader().then(({ default: ToastsManager }) => {
          ToastsManager.removeAllToasts();
        });
      } else {
        this.context.hideAllToasts();
      }
    };

    render() {
      return (
        <Subject {...this.props} hideAllToasts={this.hideAllToasts} showToast={this.showToast} />
      );
    }
  };
}
